import React, { useState, useEffect } from 'react';
import styles from '../Components/ArtCard.module.css';

// PopupImage component
const ArtCard = ({ src, alt, title }: any) => {
  const [isOpen, setIsOpen] = useState(false);

  // Function to open the popup
  const openPopup = () => setIsOpen(true);

  // Function to close the popup
  const closePopup = () => setIsOpen(false);

    useEffect(() => {
    }, [setIsOpen])

  return (
    <>
      <img 
        src={src}
        alt={alt} 
        onClick={openPopup}
        loading='lazy'
        title={title}
        className={styles.artCard}
      />

      {/* Popup (modal) */}
      {isOpen && (
        <div className={styles.overlay} onClick={closePopup}>
          <div className={styles.popup}>
            <button className={styles.closeButton} onClick={closePopup}>
              X
            </button>
            <img src={src} alt={alt} className={styles.popupImage} loading='lazy' />
          </div>
        </div>
      )}
    </>
  );
};



export default ArtCard;
